import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Header from "./Component/Header/Header";
import Features from "./Pages/FeaturesPage";
import Plans from "./Pages/PlansPage";
import Contactus from "./Pages/ContactusPage";
import Footer from "./Component/Footer/Footer";
import GetinTouch from "./Pages/RequestDemo";
import SchoolPartnership from "./Component/SchoolPartnership/SchoolPartnership";
import HomePageBrick from "./Component/Brick/HomePageBrick";
import { useSelector } from "react-redux";
import NotFound from "./Pages/NotFound";
import { ScrollTop } from "primereact/scrolltop";
import Seo from "./Seo/Seo";

function RoutePage() {
  const isLoggedIn = true;
  const location = useLocation();
  const isFullWidthRoute = location.pathname === "/CustomerEnquiry";

  return (
    <>
      <Seo />
      <Header />
      <ScrollTop className="rounded-circle" />
      <Routes>
        <Route path="/" element={<Plans />} />
        <Route path="/AboutUs" element={<Features />} />
        <Route path="/Brick" element={<HomePageBrick />} />
        <Route path="/ContactUs" element={<Contactus />} />
        <Route path="/SchoolPartnership" element={<SchoolPartnership />} />
        <Route path="*" element={<NotFound />} />
        {/* <Route path="/RequestDemo" element={<GetinTouch />} /> */}
      </Routes>
      <Footer />
    </>
  );
}

export default RoutePage;
